/** Mensagem de tabela sem linhas: o locale global do Prime dá ao `DataTable` o texto do Dropdown ("Nenhuma opção disponível."). */
export const TABLE_EMPTY_MESSAGE = "Nenhum registro encontrado.";
